module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.tabs) ? _c('div', {
    staticClass: "flex-tabs",
    class: {
      'tab-wrapper no-select': true, 'min': _vm.$props.min
    }
  }, _vm._l((_vm.tabs), function(tab, i) {
    return _c('md-button', {
      key: i,
      class: {
        'label': true, 'active': (_vm.value == tab.name), 'error': tab.error
      },
      attrs: {
        "id": (tab.name) ? tab.name : ('tab-' + i)
      },
      on: {
        "click": function($event) {
          _vm.changeTab(tab.name)
        }
      }
    }, [_vm._v(_vm._s((tab.label) ? tab.label : ''))])
  })) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f38e584e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FlexTabs.vue
// module id = 1278
// module chunks = 0